// extracted by mini-css-extract-plugin
export default {"header":"aWdbPHOnoEEx2m2unlG5","title":"kJxVoLBC2xvpcWcmlS3f"};